import { Component } from '@angular/core';
import { ActivitiesComponent } from '../../../organisms/activities/activities.component';
import { LeaderBoardComponent } from '../../../organisms/leader-board/leader-board.component';
import { MainLayoutComponent } from '../../../organisms/main-layout/main-layout.component';

@Component({
  selector: 'app-home',
  templateUrl: './home.component.html',
  imports: [MainLayoutComponent, LeaderBoardComponent, ActivitiesComponent],
})
export class HomeComponent {}
